var nonCssSizes = [];

var Modernizr = window.Modernizr;

var sizes = (function (arr) {
    var obj = {};
    var prev = null;
    for (var i in arr) {
        obj[arr[i].short] = Object.create(arr[i]);
        obj[arr[i].short].prev = prev;
        if (!obj[arr[i].short].inCss) {
            nonCssSizes.push(obj[arr[i].short]);
        }
        prev = obj[arr[i].short];
    }
    return obj;
})(require('../../data/grid').sizes);

var verifySize = function (size) {
    if (size in sizes) {
        if (sizes[size].prev) {
            if (!sizes[size].breakpoint) {
                if (!Modernizr.mq('(min-width: ' + sizes[size].prev.breakpoint + 'px)'))
                    return false;
            } else
            if (!Modernizr.mq('(min-width: ' + sizes[size].prev.breakpoint + 'px) and (max-width: ' + sizes[size].breakpoint + 'px)'))
                return false;
        } else if (!Modernizr.mq('(max-width: ' + sizes[size].breakpoint + 'px)'))
            return false;
        return true;
    } else
        return false;
}

var onResize = function () {
    for (var i in sizes) {
        var size = sizes[i];
        $('body').toggleClass('is-' + size.short, verifySize(size.short));
    }
};

$().ready(function () {
    $(window).on('load', onResize);
    $(window).on('resize', onResize);
});

module.exports = {
    sizes: sizes,
    verifySize: verifySize
};
